export default function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/treemap/round.js
// module id = 261
// module chunks = 0